import { render } from "./CriteriaView.vue?vue&type=template&id=7b435787"
import script from "./CriteriaView.vue?vue&type=script&lang=js"
export * from "./CriteriaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__